export default [
	{
		path: "/admin/clients",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminClients",
		mui: true,
	},
];
